import { z } from 'zod';

export interface SecureHeader {
  id: string;
  domain?: string;
}

export function extractDomain(url?: string): string {
  if (!url) {
    return '';
  }
  try {
    return new URL(url).host;
  } catch {
    return '';
  }
}

// Domain is optional because we will only ever have a secure header object
// until pressing save at which point we load a list of IDs from the API
// FIXME: Add a proper typeahead for secure headers (instead of BlockAutocomplete)
export const SecureHeaderSchema = z.object({
  id: z.uuid(),
  domain: z.string().optional(),
});
